import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/auth/auth.service";

export const subscribedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Students don't need subscriptions - they should be redirected to student area
  if (auth.isStudent) {
    router.navigate(["/student"]);
    return false;
  }

  if (!auth.authenticated) {
    router.navigate(["signin"]);
    return false;
  }

  // Entry gate: personal subscription OR active site membership grants access.
  if (auth.canUseApp) {
    return true;
  }

  router.navigate(["subscribe"]);
  return false;
};
